import {useNavigate, useSearchParams} from "react-router-dom";
import {useRpcSender} from "../../../RpcSender";
import {useState} from "react";
import {RpcState} from "../../../util/RpcState";
import {
  BookAppointmentRequest,
  BookAppointmentResponse,
  IBookAppointmentRequest,
  IBookAppointmentResponse
} from "../../../compiled";

export const useBookAppointmentRpc = () => {

  const navigate = useNavigate();
  const rpcSender = useRpcSender();

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [response, setResponse] = useState<IBookAppointmentResponse>();

  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('v') === 'DRAFT'

  const send = (request: IBookAppointmentRequest) => {

    if (isPreview) {
      setRpcState({state: 'error', message: 'Booking is disabled in preview mode.'});
      return;
    }
    
    setRpcState({state: 'pending'})
    rpcSender.send('book_appointment', BookAppointmentRequest.encode(request).finish())
        .then(bytes => {
          let response = BookAppointmentResponse.decode(bytes);
          if (response.okay && response.appointment) {
            setRpcState({state: 'success'})
            navigate('/confirmation?b=' + response.appointment.bookingId);

          } else {
            setRpcState({state: 'error', message: response.error});
            setResponse(response);
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error booking class!'});
        });
  }
  
  return { send, rpcState, response };
}